import { AdminRoleExampleConfig } from 'main/content/auth/admin-role-example/AdminRoleExampleConfig';
import { StaffRoleExampleConfig } from 'main/content/auth/staff-role-example/StaffRoleExampleConfig';
import { GuestRoleExampleConfig } from 'main/content/auth/only-guest-role-example/GuestRoleExampleConfig';

export const authRoleExamplesConfigs = [
  AdminRoleExampleConfig,
  StaffRoleExampleConfig,
  GuestRoleExampleConfig
];



// WEBPACK FOOTER //
// ./src/main/content/auth/authRoleExamplesConfigs.js